<script>
/**
 * 带loading效果的按钮
 * @author lvxin08
 */
export default {
    name: 'XxLoadingButton',
    props: {
        /**
         * 点击事件处理函数
         */
        click: {
            type: Function,
            default: () => () => { }
        }
    },
    data() {
        return {
            events: null,
            loading: false
        };
    },
    methods: {
        _click() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            const task = this.click(this.done.bind(this));
            if (task && task.then) {
                task.then(() => this.done());
            }
            if (task && task.catch) {
                task.catch(() => this.done());
            }
            /**
             * 点击事件
             * @event click
             * @type {Function} 组件的引用
             */
            this.$emit('click', this.done.bind(this));
        },
        done() {
            this.loading = false;
        }
    },
    render(create) {
        return create(
            'el-button',
            {
                props: {
                    ...this.props
                },
                attrs: {
                    ...this.$attrs,
                    size: this.$attrs.size || 'small',
                    loading: this.loading
                },
                on: {
                    ...this.$listeners,
                    click: this._click
                }
            },
            /**
             * @slot 按钮内容
             */
            this.$slots.default
        );
    }
};
</script>
